class Enum {
    constructor(map) {
        this.map = map;
    }

    getOptions () {
        let options = [];
        for (let key in this.map) {
            options.push({ key: key, value: this.map[key] });
        }
        return options;
    }

    getValue (key) {
        return this.map[key];
    }
}

const CouseType = new Enum({
    2: "大班课",
    // 3: "小班课",
    4: "公开课",
    5: "点播课",
    7: "面授课",
    8: "音频课",
    9: "系统课",
    10: "图文课",
});

const CourseStatus = new Enum({
    1: "已上架",
    2: "已下架",
    3: "待上架"
});

const CoursePublicStatus = new Enum({
    0: "不显示",
    1: "显示"
});

// 学员状态
const StudentStatus = new Enum({
    0: '禁用',
    1: '启用'
})

//移动端意见反馈状态
const ReadStatus = new Enum({
    1: '已读',
    2: '未读'
})
// 导出任务类型
const ExportTaskType = new Enum({
    1: '导出学生',
    2: '导出讲师',
    3: '导出订单',
    4: '导出会员',
    5: '导出助教'
})

// 导出任务状态
const ExportTaskStatus = new Enum({
    0: '待启动',
    1: '进行中',
    2: '已完成'
})

// 订单类型
const OrderType = new Enum({
    2: '课程订单',
    4: '图书订单',
    5: '练习订单',
    6: '模考订单'
})

// 订单状态
const OrderStatus = new Enum({
    1: '待支付',
    2: '交易完成',
    3: '交易取消'
})

// 支付状态
const PayStatus = new Enum({
    1: '待支付',
    2: '已支付',
    3: '退款申请中',
    4: '退款中',
    5: '已退款',
    6: '退款失败'
})

// 发货状态
const ShipStatus = new Enum({
    1: '待发货',
    2: '无需发货',
    3: '已发货',
    4: '已收货'
})

// 支付类型
const PayType = new Enum({
    1: '微信',
    2: '支付宝',
    3: '金币支付',
    4: '苹果支付',
    5: '学习卡兑换',
    6: '赠送',
    7: '优惠券支付',
    8: '线下支付',
    9: '余额支付',
    10: '积分兑换'
})

// 学习情况
const StudyStatus = new Enum({
    0: '未完成',
    1: '已完成'
})

// banner平台
const BannerPlatform = new Enum({
    1: 'PC',
    2: '安卓',
    3: 'IOS',
    4: 'H5',
    // 5: '小程序'
})

// 终端
const Terminal = new Enum({
    1: 'PC',
    2: '安卓',
    3: 'IOS',
    4: 'H5',
    // 5: '小程序',
    6: '微信内置H5',
    // 7: 'IPAD'
})

// 支付单状态
const PaymentsStatus = new Enum({
    0: '准备发起支付',
    1: '支付成功',
    2: '支付失败',
    3: '取消'
})

// 退款单状态
const RefundStatus = new Enum({
    1: '未审核',
    2: '已审核',
    3: '已取消',
    4: '退款失败',
})

const MobileRecomment = new Enum({
    1: '课程',
    // 2: '会员课程',
    3: '讲师',
    // 4: '约课讲师',
    5: '资讯',
    6: '图书',
    7: '章节练习',
    8: '模拟考试'
})

// 试卷类型
const QuestionPaperType = new Enum({
    0: '人工卷',
    1: '随机卷'
})

// 试卷状态
const QuestionPaperStatus = new Enum({
    0: '禁用',
    1: '启用'
})

// 套卷状态
const QuestionPaperPackageStatus = new Enum({
    1: '发布',
    2: '撤回'
})

// 试题类型
const QuestionType = new Enum({
    1: '单选题',
    2: '多选题',
    3: '判断题',
    //4: '连线题',
    5: '简答题'
})

// 试题报错处理状态
const TopicErrorState = new Enum({
    1: '未处理',
    2: '已处理',
    3: '没有问题'
})
// 考试状态
const ExamStatus = new Enum({
    1: '进行中',
    2: '未开始',
    3: '已结束',
})

const ExamState = new Enum({
    1: '已上架',
    2: '已下架',
    3: '待上架',
})
// 属性值类型
const AttrValType = new Enum({
    1: '单选',
    2: '多选'
})

// 属性值是否必填
const AttrValRequired = new Enum({
    1: '必填',
    2: '非必填'
})

// 审核状态
const ApprovalStatus = new Enum({
    1: '审核中',
    2: '审核通过',
    3: '审核不通过'
})

// 班级类型
const ClassType = new Enum({
    1: "手动分班",
    2: "自动分班"
})

// 班级状态
const ClassState = new Enum({
    1: "未满员",
    2: "已满员"
})

// 学员信息订单状态
const ClassOrderState = new Enum({
    2: "已购买",
    3: "已退单"
})

// 作业报告状态
const HomeworkReportStatus = new Enum({
    1: "未完成",
    2: "待批阅",
    3: "已完成",
    4: "已过期",
    5: "已关闭"
});

const HomeworkStatus = new Enum({
    1: "待批阅",
    2: "已关闭",
    3: "已完成",
    4: "已过期",
    5: "未完成"
});

const BookStatus = new Enum({
    1: '已上架',
    2: '已下架',
    3: '待上架'
});

// 试题类型
const HomeworkQuestionType = new Enum({
    1: '单选题',
    2: '多选题',
    3: '判断题',
    4: '连线题',
    5: '简答题'
});

//章节练习
const ExerciseStatus = new Enum({
    1: "已上架",
    2: "已下架",
    3: "待上架"
});

//回答板块
const RepayStatus = new Enum({
    0: "全部",
    1: "未回复",
    2: "已回复"
});
// 拼团订单状态
const GroupOrderStatus = new Enum({
    '-1': '已取消',
    1: '待支付',
    2: '拼团中',
    3: '已完成',
    4: '待发货',
    5: '已发货',
    6: '退款成功',
    7: '退款中',
    8: '退款失败',
    9: '退款申请中'
})
const ShopType = new Enum({
    2: "大班课",
    3: "小班课",
    4: "公开课",
    5: "点播课",
    7: "面授课",
    8: "音频课",
    9: "系统课",
    10: "图文课",
    12: "图书",
    13: "文库",
    14: "会员"
});

const GroupBookingStatus = new Enum({
    1: '进行中',
    2: '未开始',
    3: '已结束'
});


const IntegralExchangeStatus = new Enum({
    1: "待发货",
    2: "已完成",
    3: "已发货"
});

// 业务状态
const BusinessStatus = new Enum({
    1: '成功',
    2: '失败'
})

const IntegralGoodsType = new Enum({
    1: "课程",
    2: "图书"
});

const IntegralGoodsStatus = new Enum({
    1: "已上架",
    2: "已下架",
    3: "待上架"
});


const TerminalType = new Enum({
    1: "PC",
    2: "安卓",
    3: "IOS",
    4: "H5",
    // 5: "小程序",
    6: "微信内置H5",
    7: "IPAD",
    99: "管理端"
});

const JoinFrom = new Enum({
    1: "凑团入口",
    2: "微信",
    3: "朋友圈",
    4: "QQ",
    5: "QQ空间",
    6: "微博",
    7: "图片分享",
});

const GroupStatus = new Enum({
    1: '已成团',
    2: '待成团',
    3: '拼团失败'
});

const CourseType = CouseType;
export {
    CouseType,
    CourseType,
    CourseStatus,
    CoursePublicStatus,
    StudentStatus,
    ReadStatus,
    ExportTaskType,
    ExportTaskStatus,
    OrderType,
    OrderStatus,
    PayStatus,
    ShipStatus,
    PayType,
    StudyStatus,
    BannerPlatform,
    Terminal,
    PaymentsStatus,
    RefundStatus,
    MobileRecomment,
    QuestionPaperType,
    QuestionPaperStatus,
    QuestionPaperPackageStatus,
    QuestionType,
    ExamStatus,
    ExamState,
    TopicErrorState,
    AttrValType,
    AttrValRequired,
    ApprovalStatus,
    ClassType,
    ClassState,
    ClassOrderState,
    HomeworkStatus,
    HomeworkReportStatus,
    BookStatus,
    HomeworkQuestionType,
    ExerciseStatus,
    ShopType,
    RepayStatus,
    GroupBookingStatus,
    GroupOrderStatus,
    IntegralExchangeStatus,
    IntegralGoodsStatus,
    IntegralGoodsType,
    BusinessStatus,
    TerminalType,
    JoinFrom,
    GroupStatus
};
